export const tableMixin = {
    data() {
        return {
            headerCell: {background:'rgba(59,140,255,0.2)',height:'44px',textAlign:'center'}
        }
    },
    mounted() {
    },
    methods: {
        
    },   
}


// WEBPACK FOOTER //
// ./src/public/js/mixins.js